<kilowant-header [isBuyer]="false" title="kilowant University" [kilowantU]="true" [isHome]="(!isLogged)?true:false" [linkHome]="linkHome"></kilowant-header>
<div class="wrapperMain">
    <div class="form buyer">
        <div class="hidden" #beforeYouBegin>
            <a class="ku-logo"></a>
            <div>
                <b class="font21">Before you begin…</b><br>Please take our 60 second energy purchasing tutorial!
            </div>
        </div>
        <div>
            <div class="card mainUserHomeCard mt-20">
                <div class="body energy-purchasing auto-height">
                    <div>
                        <p>
                            Your electric utility bill is comprised of two categories: <b>Delivery Services</b> and <b>Supply Services.</b>
                        </p>
                        <div>
                            <div class="d-flex">
                                <a class="tower"></a>
                                <P>
                                    <b>Delivery Services are</b> costs associated with the distribution of energy ..., which are regulated and <b>provided only by your utility.</b>
                                </P>
                            </div>
                            <div class="d-flex">
                                <a class="wing"></a>
                                <a></a>
                                <p>
                                    <b>Supply Services are</b> costs associated with the generation of energy ..., which are deregulated and <b>open to customer choice.</b>
                                </p>
                            </div>
                        </div>
                        <p>
                            Supply Services typically account for 45% - 65% of your monthly bill dependent upon unit price and energy usage. <b>When you select an energy price plan through kilowant, you're buying the Supply Services component of your bill.</b>

                        </p>
                    </div>
                    <div>
                        <p class="mb-0">
                            Your utility is just one of many providers offering Supply Services, but they offer only one rate term and their rate lags the real time market by several months due to  regulatory filing, hearing, and approval processes.
                        </p>
                        <a class="kilowant-price-lock-img"></a>
                        <p>
                            Because the utility does not offer (i) live market  pricing or (ii) the option to lock in your rate when market conditions are favorable.
                        </p>
                        <p>
                            <b>
                                Consumers must go to the third-party supply markets to purchase energy at a time and duration of your choosing.
                            </b>
                        </p>
                    </div>
                    <div>
                        <p>
                            <b>kilowant solves for the lowest cost Supply Service option available for your utility account</b> via AI automated search, evaluation, and transaction 24/7.
                        </p>
                        <p>
                            Kilowant filters out the market noise by providing you with only price plan offers that will save you money relative to your utility and/or community energy alternative.
                        </p>
                        <div>
                            <p class="mat-logo mb-0">
                                <a class="yellow-bolt"></a> <b class="ml-10">Multiple price plans</b>
                            </p>
                            <p class="mat-logo mb-0"><a class="yellow-bolt"></a> <b class="ml-10">AI assisted evaluation</b></p>
                            <p class="mat-logo"><a class="yellow-bolt"></a> <b class="ml-10">Billed through your utility</b></p>
                        </div>
                        <p>
                            Additionally, <b>kilowant's Nonstop Shop<sup class="f13">TM</sup> ai purchasing agent</b> affords you the option to outsource your energy procurement to us.  Simply subscribe to the desired level of savings, and we'll take care of the rest…reporting back with how much you saved!
                        </p>
                    </div>
                    <button type="button"
                            class="yellow-button w-40 homebtnnext"
                            (click)="finish()">
                        GOT IT
                    </button>
                    <div class="clear"></div>
                </div>
            </div>
        </div>
    </div>
</div>